"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ButtonDoSync_1 = require("../../../../../../shared/components/buttons/ButtonDoSync");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var ButtonLockLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockLockAll");
var ButtonLockUnLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockUnLockAll");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var CfgCurrencyList = /** @class */ (function (_super) {
    __extends(CfgCurrencyList, _super);
    function CfgCurrencyList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchISOInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    CfgCurrencyList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchISOFilter: [],
            searchISOValue: "",
            searchTitleFilter: [],
            searchTitleValue: ""
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    CfgCurrencyList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    CfgCurrencyList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    CfgCurrencyList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    CfgCurrencyList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    CfgCurrencyList.prototype.onClearISOFilter = function () {
        this.setState({ searchISOFilter: [], searchISOValue: "" });
    };
    CfgCurrencyList.prototype.onChangeISOFilter = function (e) {
        this.setState({ searchISOValue: e.target.value });
    };
    CfgCurrencyList.prototype.onConfirmISOFilter = function () {
        this.setState({ searchISOFilter: [this.state.searchISOValue] });
    };
    CfgCurrencyList.prototype.getColumns = function () {
        var _this = this;
        var _iso_filter = this.state.searchISOFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [
            {
                title: this.props.lang.list.rows.title,
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                },
                sorter: function (a, b) { return a.title.localeCompare(b.title); },
            }, {
                title: this.props.lang.list.rows.iso,
                dataIndex: this.props.data.dk_iso,
                key: this.props.data.dk_iso,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchISOInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E iso", value: _this.state.searchISOValue, onChange: _this.onChangeISOFilter.bind(_this), onPressEnter: function () { _this.onConfirmISOFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmISOFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearISOFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _iso_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.iso.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchISOInput.focus();
                        });
                    }
                },
                sorter: function (a, b) { return a.iso.localeCompare(b.iso); },
            }, {
                title: this.props.lang.list.rows.symbol,
                dataIndex: this.props.data.dk_symbol,
                key: this.props.data.dk_symbol,
                width: 150,
            }, {
                title: this.props.lang.list.rows.exchange_rate,
                dataIndex: this.props.data.dk_rate,
                key: this.props.data.dk_rate,
                sorter: function (a, b) { return a.rate - b.rate; },
                width: 150,
            }, {
                title: this.props.lang.list.rows.is_base.title,
                dataIndex: this.props.data.dk_is_base,
                key: this.props.data.dk_is_base,
                width: 150,
                align: "center",
                render: function (text, record, idx) {
                    var _r_state = _this.props.lang.list.rows.is_base.view.no;
                    var _r_color = "#f5222d";
                    var _r_icon = "square";
                    if (record.is_base) {
                        _r_state = _this.props.lang.list.rows.is_base.view.yes;
                        _r_color = "#1890ff";
                        _r_icon = "check-square";
                    }
                    return (React.createElement("div", { style: { color: "" + _r_color } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: _r_icon }),
                        " ",
                        _r_state));
                },
                filters: [
                    { text: this.props.lang.list.rows.is_base.filter.base, value: 'true' },
                    { text: this.props.lang.list.rows.is_base.filter.derivative, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_base === (value === 'true'); },
                sorter: function (a, b) { return UIUtils_1.UIUtils.bool2Int(a.is_base) - UIUtils_1.UIUtils.bool2Int(b.is_base); },
            }, {
                title: this.props.lang.list.rows.is_actual.title,
                dataIndex: this.props.data.dk_is_deprecated,
                key: this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: {
                            menu: _this.props.lang.list.rows.is_actual.menu.deprecate.menu,
                            text: _this.props.lang.list.rows.is_actual.menu.deprecate.text
                        }, notDeprecatedTexts: {
                            menu: _this.props.lang.list.rows.is_actual.menu.actual.menu,
                            text: _this.props.lang.list.rows.is_actual.menu.actual.text
                        }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                filters: [
                    { text: this.props.lang.list.rows.is_actual.filter.deprecate, value: 'true' },
                    { text: this.props.lang.list.rows.is_actual.filter.actual, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_deprecated === (value === 'true'); },
                sorter: function (a, b) { return UIUtils_1.UIUtils.bool2Int(a.is_deprecated) - UIUtils_1.UIUtils.bool2Int(b.is_deprecated); },
                width: 150,
            }, {
                title: this.props.lang.list.rows.is_fun.title,
                dataIndex: this.props.data.dk_is_fun,
                key: this.props.data.dk_is_fun,
                align: "center",
                render: function (text, record, idx) {
                    var _r_state = _this.props.lang.list.rows.is_fun.view.no;
                    var _r_color = "#f5222d";
                    var _r_icon = "square";
                    if (record.is_fun) {
                        _r_state = _this.props.lang.list.rows.is_fun.view.yes;
                        _r_color = "#1890ff";
                        _r_icon = "check-square";
                    }
                    return (React.createElement("div", { style: { color: "" + _r_color } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: _r_icon }),
                        " ",
                        _r_state));
                },
                filters: [
                    { text: this.props.lang.list.rows.is_fun.filter.demo, value: 'true' },
                    { text: this.props.lang.list.rows.is_fun.filter.money, value: 'false' },
                ],
                filterMultiple: false,
                onFilter: function (value, record) { return record.is_fun === (value === 'true'); },
                sorter: function (a, b) { return UIUtils_1.UIUtils.bool2Int(a.is_fun) - UIUtils_1.UIUtils.bool2Int(b.is_fun); },
                width: 200,
            } /*, {
                title: this.props.lang.list.rows.updated,
                dataIndex: this.props.data.dk_date_changed,
                key: this.props.data.dk_date_changed,
                width: 200,
                render: (text, record, idx) => {
                    return(
                        <div>{record.date_changed.format(this.props.state.getDateTimeFormat())}</div>
                    )
                }
            }*/,
            {
                title: this.props.lang.list.rows.action.title,
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: _this.props.lang.list.rows.action.edit, onClick: function () { _this.onEditCurrencyClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: _this.props.lang.list.rows.action.delete.hint, confirmText: _this.props.lang.list.rows.action.delete.confirm, onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
    };
    CfgCurrencyList.prototype.onEditCurrencyClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    CfgCurrencyList.prototype.onDeleteClick = function (record) {
        var _this = this;
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.currency_deleted_fmt, [record.title]));
        });
    };
    CfgCurrencyList.prototype.doDeprecateAction = function (key, title, deprecate) {
        var _this = this;
        this.props.data.DoSetIsDeprecatedOne(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_all_currency_is_deprecated, [title]));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotificationText(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.set_all_currency_is_actual, [title]));
            }
        });
    };
    CfgCurrencyList.prototype.OnImportDataClick = function () {
        var _this = this;
        this.props.data.ImportCurrency(function (added_cnt, updated_cnt) {
            _this.props.data.LoadData(function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.message.currency_imported_fmt, [added_cnt.toString(), updated_cnt.toString()]));
            });
        });
    };
    CfgCurrencyList.prototype.onLockAllClick = function () {
        var _this = this;
        this.props.data.DoSetIsDeprecatedAll(true, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.set_all_currency_is_deprecated);
        });
    };
    CfgCurrencyList.prototype.onUnLockAllClick = function () {
        var _this = this;
        this.props.data.DoSetIsDeprecatedAll(false, function () {
            notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.set_all_currency_is_actual);
        });
    };
    CfgCurrencyList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    CfgCurrencyList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.data.LoadData(function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.list.message.currency_loaded);
            });
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    CfgCurrencyList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: {
                    create: this.props.lang.list.toolbars.hints.create,
                    refresh: this.props.lang.list.toolbars.hints.refresh
                }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: this.props.lang.list.toolbars.import_all.confirm_title, okText: this.props.lang.list.toolbars.import_all.ok_text, cancelText: this.props.lang.list.toolbars.import_all.cancel_text, onConfirm: this.OnImportDataClick.bind(this) },
                    React.createElement(ButtonDoSync_1.default, { hint: this.props.lang.list.toolbars.import_all.button_hint, onClick: function () { } })),
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: this.props.lang.list.toolbars.lock_all.confirm_title, okText: this.props.lang.list.toolbars.lock_all.ok_text, cancelText: this.props.lang.list.toolbars.lock_all.cancel_text, onConfirm: this.onLockAllClick.bind(this) },
                    React.createElement(ButtonLockLockAll_1.default, { hint: this.props.lang.list.toolbars.lock_all.button_hint, onClick: function () { } })),
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: this.props.lang.list.toolbars.unlock_all.confirm_title, okText: this.props.lang.list.toolbars.unlock_all.ok_text, cancelText: this.props.lang.list.toolbars.unlock_all.cancel_text, onConfirm: this.onUnLockAllClick.bind(this) },
                    React.createElement(ButtonLockUnLockAll_1.default, { hint: this.props.lang.list.toolbars.unlock_all.button_hint, onClick: function () { } }))),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null, UIUtils_1.UIUtils.FormatStr(_this.props.lang.list.footer.title_fmt, [data.length.toString()]));
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.created),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, _this.props.lang.list.details.changed),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return CfgCurrencyList;
}(React.Component));
exports.default = CfgCurrencyList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ui/component/CfgCurrencyList.tsx
// module id = 2040
// module chunks = 0